import { createSelector } from '@ngrx/store';

import * as solutionsMain from '../reducers';
import * as solutionsMainSub from '../reducers/get-selected-product-solution.reducer';

export const getSelectedProductSolutionResponse = createSelector(
  solutionsMain.selectedProductSolutionState,
  solutionsMainSub.getSelectedProductSolution
);

export const getSelectedProductSolutionLoaded = createSelector(
  solutionsMain.selectedProductSolutionState,
  solutionsMainSub.getSelectedProductSolutionLoaded
);
